import { useState, useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import api from '../services/api'
import { useNavegacaoLista } from '../hooks/useNavegacaoLista'
import IconExcluir from '../components/icons/IconExcluir'

const PRIMARY = 'var(--primary)'
const SECONDARY = '#745700'

function saudacao() {
  const h = new Date().getHours()
  if (h < 12) return 'Bom dia'
  if (h < 18) return 'Boa tarde'
  return 'Boa noite'
}


const DIAS_SEMANA = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']
const isoLocal = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
const capitalizar = (s) => s ? s.charAt(0).toUpperCase() + s.slice(1) : s

// Domingo de Pascoa (algoritmo de Gauss) — base pros feriados moveis (Carnaval, Sexta-feira Santa,
// Corpus Christi), que mudam de data todo ano.
function domingoPascoa(ano) {
  const a = ano % 19, b = Math.floor(ano / 100), c = ano % 100
  const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25)
  const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30
  const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7
  const m = Math.floor((a + 11 * h + 22 * l) / 451)
  const mes = Math.floor((h + l - 7 * m + 114) / 31)
  const dia = ((h + l - 7 * m + 114) % 31) + 1
  return new Date(ano, mes - 1, dia)
}
const somarDias = (d, n) => new Date(d.getFullYear(), d.getMonth(), d.getDate() + n)

// Feriados nacionais do ano (fixos + moveis a partir da Pascoa), como um Set de datas "YYYY-MM-DD"
// pra consulta O(1) na grade do calendario.
function feriadosNacionais(ano) {
  const pascoa = domingoPascoa(ano)
  const datas = [
    new Date(ano, 0, 1),   // Confraternização Universal
    somarDias(pascoa, -47), // Carnaval (terça)
    somarDias(pascoa, -2),  // Sexta-feira Santa
    somarDias(pascoa, 60),  // Corpus Christi
    new Date(ano, 3, 21),  // Tiradentes
    new Date(ano, 4, 1),   // Dia do Trabalho
    new Date(ano, 8, 7),   // Independência
    new Date(ano, 9, 12),  // Nossa Senhora Aparecida
    new Date(ano, 10, 2),  // Finados
    new Date(ano, 10, 15), // Proclamação da República
    new Date(ano, 10, 20), // Consciência Negra
    new Date(ano, 11, 25), // Natal
  ]
  return new Set(datas.map(isoLocal))
}

// ===== Home — pagina inicial de todos os usuarios (Dashboard continua existindo, mas so pro
// Administrador). Cards com numeros reais (nao mockados como no Dashboard antigo). =====
export default function Home() {
  const navigate = useNavigate()
  const { usuario } = useAuth()
  const [carregando, setCarregando] = useState(true)
  const [renovacoes, setRenovacoes] = useState(0)
  const [novos, setNovos] = useState(0)
  const [refeitos, setRefeitos] = useState(0)
  const [cancelados, setCancelados] = useState(0)
  const [propostas, setPropostas] = useState(0)
  const [sinistros, setSinistros] = useState(0)
  const [clientes, setClientes] = useState([])
  // Muda quando a janela do dia manda tarefas pro ToDo, pra o card recarregar a lista
  const [todoVersao, setTodoVersao] = useState(0)

  useEffect(() => {
    // Contagens calculadas no servidor (regras em GET /apolices/contagens-home) — antes baixava
    // as tabelas inteiras de apolices e sinistros so pra contar aqui.
    Promise.allSettled([
      api.get('/apolices/contagens-home'),
      api.get('/clientes'),
    ]).then(([contagensRes, clientesRes]) => {
      if (contagensRes.status === 'fulfilled') {
        const c = contagensRes.value.data || {}
        setRenovacoes(c.renovacoes || 0)
        setNovos(c.novos || 0)
        setRefeitos(c.refeitos || 0)
        setCancelados(c.cancelados || 0)
        setPropostas(c.propostas || 0)
        setSinistros(c.sinistros || 0)
      }
      if (clientesRes.status === 'fulfilled') {
        setClientes(Array.isArray(clientesRes.value.data) ? clientesRes.value.data : [])
      }
    }).finally(() => setCarregando(false))
  }, [])

  // "Novo Negócio"/"Novo Sinistro" abrem direto o formulario na tela de destino (mesmo padrao de
  // sessionStorage ja usado em Apolices>Ações>Sinistros) — a propria pagina remove a flag ao ler.
  const novoNegocio = () => { sessionStorage.setItem('crmAbrirNovo', '1'); navigate('/crm') }
  const novoSinistro = () => { sessionStorage.setItem('sinistroAbrirNovo', '1'); navigate('/sinistros') }

  const hoje = new Date()
  const dataFormatada = hoje.toLocaleDateString('pt-BR', { day: 'numeric', month: 'long', year: 'numeric' })
  const fmt = (n) => carregando ? '—' : `${n}`

  return (
    <div style={{ fontFamily: 'Manrope, sans-serif', minHeight: '100vh' }}>
      <div className="page-content" style={{ padding: '32px 36px 40px' }}>

        <header style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', marginBottom: 36, flexWrap: 'wrap', gap: 16 }}>
          <div>
            <p style={{ fontSize: 10, fontWeight: 700, color: '#aaa', textTransform: 'uppercase', letterSpacing: '0.12em', marginBottom: 4 }}>
              {dataFormatada}
            </p>
            <h1 style={{ fontSize: 32, fontWeight: 800, color: '#2F2F2E', margin: 0, letterSpacing: '-0.02em' }}>
              {saudacao()}, {usuario?.nome?.split(' ')[0] || 'Usuário'}
            </h1>
            <p style={{ fontSize: 13, color: SECONDARY, fontWeight: 600, margin: '4px 0 0', letterSpacing: '0.02em' }}>
              Bem-vindo ao Sistema de Gestão da Corretora de Seguros.
            </p>
          </div>
          <div style={{ display: 'flex', gap: 12 }}>
            <button
              onClick={novoNegocio}
              style={{
                padding: '11px 22px', background: PRIMARY, color: '#fff',
                border: 'none', borderRadius: 10, fontWeight: 700, fontSize: 13,
                cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 7,
                boxShadow: '0 4px 16px rgba(var(--primary-rgb),0.25)',
                fontFamily: 'Manrope, sans-serif',
              }}
            >
              + Nova Negociação
            </button>
            <button
              onClick={novoSinistro}
              style={{
                padding: '11px 22px', background: '#fff', color: PRIMARY,
                border: '2px solid rgba(var(--primary-rgb),0.15)', borderRadius: 10,
                fontWeight: 700, fontSize: 13, cursor: 'pointer',
                display: 'flex', alignItems: 'center', gap: 7,
                fontFamily: 'Manrope, sans-serif',
              }}
            >
              + Novo Sinistro
            </button>
          </div>
        </header>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 18 }}>
          <KPICard
            icon="⟲" label="Renovações" value={fmt(renovacoes)}
            color="var(--primary)"
            onClick={() => navigate('/propostas')}
          />
          <KPICard
            icon="+" label="Novos" value={fmt(novos)} iconSize={68}
            color="var(--primary)"
            onClick={() => navigate('/propostas')}
          />
          <KPICard
            icon="↺" label="Refeitos" value={fmt(refeitos)}
            color="var(--primary)"
            onClick={() => navigate('/propostas')}
          />
          <KPICard
            icon="✕" label="Cancelados" value={fmt(cancelados)}
            color="var(--primary-dark)"
            onClick={() => navigate('/propostas')}
          />
          <KPICard
            icon="☰" label="Propostas" value={fmt(propostas)}
            color="var(--primary)"
            onClick={() => navigate('/propostas')}
          />
          <KPICard
            icon="⚠" label="Sinistros" value={fmt(sinistros)}
            color="var(--primary-dark)"
            onClick={() => navigate('/sinistros')}
          />
        </div>

        <div style={{ display: 'flex', gap: 18, marginTop: 18, alignItems: 'flex-start', flexWrap: 'wrap' }}>
          <div style={{ flex: '1 1 620px', minWidth: 380 }}>
            <AgendaCompromissos clientes={clientes} />
          </div>
          <div style={{ flex: '0 1 320px', minWidth: 280, display: 'flex', flexDirection: 'column', gap: 18 }}>
            <TodoDia key={todoVersao} />
            <CardSeguradoras />
          </div>
        </div>

        <ResumoDoDia usuarioId={usuario?.id} onEnviado={() => setTodoVersao(v => v + 1)} />

      </div>
    </div>
  )
}

function AgendaCompromissos({ clientes }) {
  const { usuario } = useAuth()
  const hojeISO = isoLocal(new Date())
  const [usuarios, setUsuarios] = useState([])
  const [itens, setItens] = useState([])
  const [carregando, setCarregando] = useState(true)
  const [modo, setModo] = useState('mes')
  const [cursor, setCursor] = useState(new Date())
  const [selecionado, setSelecionado] = useState(hojeISO)

  // janela flutuante sobre o card: null (fechada) | {editandoId: null|id, titulo, data, hora, clienteId, concluido}
  const [janela, setJanela] = useState(null)
  const [buscaCliente, setBuscaCliente] = useState('')
  const [salvando, setSalvando] = useState(false)
  const [erroJanela, setErroJanela] = useState('')
  // Aviso no visual do site (em vez do alert do navegador), some sozinho depois de alguns segundos
  const [aviso, setAviso] = useState('')
  useEffect(() => {
    if (!aviso) return
    const t = setTimeout(() => setAviso(''), 4000)
    return () => clearTimeout(t)
  }, [aviso])

  const carregar = () => {
    setCarregando(true)
    api.get('/compromissos').then(res => setItens(Array.isArray(res.data) ? res.data : [])).finally(() => setCarregando(false))
  }
  useEffect(() => { carregar() }, [])
  useEffect(() => {
    api.get('/compromissos/usuarios').then(res => setUsuarios(Array.isArray(res.data) ? res.data : [])).catch(() => {})
  }, [])

  const porDia = useMemo(() => {
    const m = {}
    itens.forEach(it => {
      const k = it.data.split('T')[0]
      ;(m[k] = m[k] || []).push(it)
    })
    Object.values(m).forEach(lista => lista.sort((a, b) => (a.hora || '').localeCompare(b.hora || '')))
    return m
  }, [itens])

  const clientesFiltrados = buscaCliente.trim().length >= 2
    ? clientes.filter(c => c.nome?.toLowerCase().includes(buscaCliente.toLowerCase())).slice(0, 6)
    : []
  const navCliente = useNavegacaoLista(clientesFiltrados.length, (i) => {
    const c = clientesFiltrados[i]
    setJanela(j => ({ ...j, clienteId: c.id })); setBuscaCliente('')
  })

  const abrirNovo = () => {
    setBuscaCliente('')
    setJanela({ editandoId: null, titulo: '', data: selecionado, hora: '', clienteId: null, concluido: false, descricao: '', usuarioId: usuario?.id || '' })
  }

  const abrirItem = (item) => {
    setBuscaCliente('')
    setJanela({
      editandoId: item.id, titulo: item.titulo, data: item.data.split('T')[0],
      hora: item.hora || '', clienteId: item.cliente_id || null, concluido: !!item.concluido,
      descricao: item.descricao || '', criadoPorNome: item.criado_por_nome || null,
      delegado: !!item.delegado, donoNome: item.dono_nome || '',
    })
  }

  const fecharJanela = () => { setJanela(null); setErroJanela('') }

  const salvar = async () => {
    if (!janela.titulo.trim() || !janela.data) return
    setSalvando(true)
    setErroJanela('')
    try {
      const payload = { titulo: janela.titulo.trim(), data: janela.data, hora: janela.hora || null, cliente_id: janela.clienteId, descricao: janela.descricao || null }
      if (janela.editandoId) {
        await api.put(`/compromissos/${janela.editandoId}`, payload)
        // So o dono da agenda marca como concluido; quem criou pra outro so acompanha.
        if (!janela.delegado) await api.patch(`/compromissos/${janela.editandoId}/concluido`, { concluido: janela.concluido })
      } else {
        await api.post('/compromissos', { ...payload, usuario_id: janela.usuarioId || null })
        const destino = usuarios.find(u => u.id === Number(janela.usuarioId))
        setAviso(destino && destino.id !== usuario?.id ? `Compromisso criado na agenda de ${destino.nome}.` : 'Compromisso criado.')
      }
      fecharJanela()
      carregar()
    } catch (err) {
      setErroJanela(err.response?.data?.erro || 'Erro ao salvar o compromisso.')
    } finally { setSalvando(false) }
  }

  const excluir = async (id) => {
    setItens(prev => prev.filter(i => i.id !== id))
    await api.delete(`/compromissos/${id}`)
    fecharJanela()
  }

  const irHoje = () => { setCursor(new Date()); setSelecionado(hojeISO) }
  const mudarMes = (delta) => setCursor(c => new Date(c.getFullYear(), c.getMonth() + delta, 1))
  const mudarSemana = (delta) => setCursor(c => new Date(c.getFullYear(), c.getMonth(), c.getDate() + delta * 7))

  const inicioSemana = new Date(cursor.getFullYear(), cursor.getMonth(), cursor.getDate() - cursor.getDay())
  const diasSemana = Array.from({ length: 7 }, (_, i) => new Date(inicioSemana.getFullYear(), inicioSemana.getMonth(), inicioSemana.getDate() + i))

  const inicioMes = new Date(cursor.getFullYear(), cursor.getMonth(), 1)
  const inicioGrade = new Date(inicioMes.getFullYear(), inicioMes.getMonth(), inicioMes.getDate() - inicioMes.getDay())
  const diasGrade = Array.from({ length: 42 }, (_, i) => new Date(inicioGrade.getFullYear(), inicioGrade.getMonth(), inicioGrade.getDate() + i))

  // A grade de 42 dias pode pegar virada de ano (ex.: ultima semana de dezembro/1a de janeiro) —
  // junta os feriados de todo ano que aparece na grade atual, nao so o ano do cursor.
  const feriados = new Set([inicioGrade.getFullYear(), diasGrade[41].getFullYear(), cursor.getFullYear()]
    .flatMap(ano => [...feriadosNacionais(ano)]))

  const labelMes = capitalizar(cursor.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' }))
  const fimSemana = diasSemana[6]
  const fmtCurto = (d) => d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' })
  const labelSemana = `${fmtCurto(inicioSemana)} – ${fmtCurto(fimSemana)}`

  const fmtLongo = (iso) => capitalizar(new Date(iso + 'T00:00:00').toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long' }))

  const Celula = ({ dia, alto }) => {
    const iso = isoLocal(dia)
    const doMes = dia.getMonth() === cursor.getMonth()
    const isHoje = iso === hojeISO
    const isSel = iso === selecionado
    const isFimDeSemana = dia.getDay() === 0 || dia.getDay() === 6
    const isFeriado = feriados.has(iso)
    const diferenciado = isFimDeSemana || isFeriado
    const lista = porDia[iso] || []
    const maxItens = alto ? 4 : 2
    return (
      <div
        onClick={() => setSelecionado(iso)}
        title={isFeriado ? 'Feriado nacional' : undefined}
        style={{
          minHeight: alto ? 132 : 74, padding: 6, borderRadius: 8, cursor: 'pointer',
          background: isSel ? 'rgba(var(--primary-rgb),0.08)' : diferenciado ? 'var(--primary-light)' : '#fff',
          border: isHoje ? `1.5px solid ${PRIMARY}` : '1px solid #f0efed',
          opacity: doMes ? 1 : 0.4,
          display: 'flex', flexDirection: 'column', gap: 3, overflow: 'hidden',
        }}
      >
        <span style={{ fontSize: 11, fontWeight: isHoje || diferenciado ? 800 : 600, color: isHoje || diferenciado ? PRIMARY : '#555' }}>{dia.getDate()}</span>
        {lista.slice(0, maxItens).map(it => (
          <span key={it.id} onClick={e => { e.stopPropagation(); abrirItem(it) }}
            title={it.delegado ? `Para: ${it.dono_nome}` : undefined}
            style={it.delegado ? {
              // Criado por mim na agenda de outro usuario: contorno tracejado, sem fundo cheio
              fontSize: 9.5, fontWeight: 600, color: it.concluido ? '#aaa' : SECONDARY, background: '#fff',
              border: `1px dashed ${it.concluido ? '#bbb' : SECONDARY}`,
              borderRadius: 4, padding: '0 4px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
            } : {
              fontSize: 9.5, fontWeight: 600, color: '#fff', background: it.concluido ? '#bbb' : SECONDARY,
              borderRadius: 4, padding: '1px 4px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
            }}>{it.delegado ? '→ ' : ''}{it.hora ? `${it.hora} ` : ''}{it.titulo}</span>
        ))}
        {lista.length > maxItens && <span style={{ fontSize: 9, color: '#999', fontWeight: 700 }}>+{lista.length - maxItens}</span>}
      </div>
    )
  }

  const itensDoDia = porDia[selecionado] || []

  return (
    <div style={{ background: '#fff', borderRadius: 16, padding: '20px 22px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', position: 'relative' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14, flexWrap: 'wrap', gap: 10 }}>
        <h3 style={{ fontSize: 15, fontWeight: 800, color: '#2F2F2E', margin: 0 }}>📅 Agenda de Compromissos e Tarefas</h3>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <div style={{ display: 'flex', background: '#F9F6F5', borderRadius: 8, padding: 2 }}>
            {['mes', 'semana'].map(m => (
              <button key={m} onClick={() => setModo(m)} style={{
                border: 'none', background: modo === m ? '#fff' : 'transparent',
                boxShadow: modo === m ? '0 1px 3px rgba(0,0,0,0.12)' : 'none',
                color: modo === m ? PRIMARY : '#888', fontWeight: 700, fontSize: 11.5,
                padding: '5px 12px', borderRadius: 6, cursor: 'pointer', textTransform: 'capitalize',
              }}>{m}</button>
            ))}
          </div>
          <button onClick={abrirNovo} style={{
            border: 'none', background: 'rgba(var(--primary-rgb),0.08)', color: PRIMARY, fontWeight: 700,
            fontSize: 12, padding: '6px 12px', borderRadius: 8, cursor: 'pointer',
          }}>+ Novo</button>
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <button onClick={() => modo === 'mes' ? mudarMes(-1) : mudarSemana(-1)} style={{
            border: '1px solid #eee', background: '#fff', borderRadius: 7, width: 26, height: 26, cursor: 'pointer', fontSize: 13, color: '#666',
          }}>‹</button>
          <button onClick={() => modo === 'mes' ? mudarMes(1) : mudarSemana(1)} style={{
            border: '1px solid #eee', background: '#fff', borderRadius: 7, width: 26, height: 26, cursor: 'pointer', fontSize: 13, color: '#666',
          }}>›</button>
          <span style={{ fontSize: 13, fontWeight: 800, color: '#2F2F2E', marginLeft: 6 }}>{modo === 'mes' ? labelMes : labelSemana}</span>
        </div>
        <button onClick={irHoje} style={{
          border: '1px solid rgba(var(--primary-rgb),0.2)', background: '#fff', color: PRIMARY, fontWeight: 700,
          fontSize: 11.5, padding: '5px 10px', borderRadius: 7, cursor: 'pointer',
        }}>Hoje</button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 4, marginBottom: 4 }}>
        {DIAS_SEMANA.map((d, i) => (
          <span key={d} style={{ textAlign: 'center', fontSize: 10, fontWeight: 700, color: (i === 0 || i === 6) ? PRIMARY : '#aaa', textTransform: 'uppercase' }}>{d}</span>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 4 }}>
        {(modo === 'mes' ? diasGrade : diasSemana).map((dia, i) => (
          <Celula key={i} dia={dia} alto={modo === 'semana'} />
        ))}
      </div>

      <div style={{ marginTop: 16, borderTop: '1px solid #f0efed', paddingTop: 14 }}>
        <p style={{ margin: '0 0 10px', fontSize: 13, fontWeight: 800, color: '#2F2F2E' }}>{fmtLongo(selecionado)}</p>

        {carregando ? (
          <p style={{ fontSize: 13, color: '#999' }}>Carregando…</p>
        ) : !itensDoDia.length ? (
          <p style={{ fontSize: 13, color: '#999' }}>Nenhum compromisso nesse dia.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8, maxHeight: 220, overflowY: 'auto' }}>
            {itensDoDia.map(item => (
              <div key={item.id} onClick={() => abrirItem(item)} style={{
                display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', cursor: 'pointer',
                background: item.delegado ? '#fff' : '#F9F6F5', borderRadius: 10,
                border: item.delegado ? `1.5px dashed ${SECONDARY}` : 'none',
                opacity: item.concluido && !item.delegado ? 0.5 : 1,
              }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  {item.delegado && (
                    <p style={{ margin: '0 0 2px', fontSize: 10, fontWeight: 800, color: SECONDARY, textTransform: 'uppercase', letterSpacing: '0.04em' }}>→ Para: {item.dono_nome}</p>
                  )}
                  <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: '#2F2F2E', textDecoration: item.concluido ? 'line-through' : 'none' }}>{item.titulo}</p>
                  <p style={{ margin: '2px 0 0', fontSize: 11, color: '#999' }}>
                    {item.hora ? `${item.hora}` : 'sem horário'}{item.cliente_nome ? ` · ${item.cliente_nome}` : ''}{item.criado_por_nome ? ` · criado por ${item.criado_por_nome}` : ''}
                  </p>
                </div>
                {item.delegado
                  ? <span style={{ fontSize: 10, fontWeight: 700, color: item.concluido ? '#2F6B3A' : '#B26A00' }}>{item.concluido ? 'Concluído' : 'Pendente'}</span>
                  : item.concluido && <span style={{ fontSize: 10, fontWeight: 700, color: '#888' }}>Concluído</span>}
              </div>
            ))}
          </div>
        )}
      </div>

      {aviso && (
        <div role="status" onClick={() => setAviso('')} style={{
          position: 'absolute', top: 14, left: '50%', transform: 'translateX(-50%)', zIndex: 30,
          display: 'flex', alignItems: 'center', gap: 8, padding: '10px 16px', borderRadius: 10, cursor: 'pointer',
          background: '#2F6B3A', color: '#fff', fontSize: 13, fontWeight: 700, whiteSpace: 'nowrap',
          boxShadow: '0 6px 20px rgba(0,0,0,0.18)',
        }}>✓ {aviso}</div>
      )}

      {janela && (
        <div onClick={fecharJanela} style={{
          position: 'absolute', inset: 0, background: 'rgba(47,47,46,0.45)', borderRadius: 16,
          display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, zIndex: 20,
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: '#fff', borderRadius: 14, padding: 20, width: '100%', maxWidth: 360,
            boxShadow: '0 12px 40px rgba(0,0,0,0.25)', display: 'flex', flexDirection: 'column', gap: 10,
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h4 style={{ margin: 0, fontSize: 14, fontWeight: 800, color: '#2F2F2E' }}>
                {janela.editandoId ? 'Compromisso / Tarefa' : 'Novo Compromisso / Tarefa'}
              </h4>
              <button onClick={fecharJanela} style={{ border: 'none', background: 'none', color: '#bbb', cursor: 'pointer', fontSize: 18, lineHeight: 1 }}>✕</button>
            </div>

            {!janela.editandoId && usuarios.length > 1 && (
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: '#888', fontWeight: 700 }}>
                Agenda de
                <select value={janela.usuarioId} onChange={e => setJanela(j => ({ ...j, usuarioId: Number(e.target.value) }))}
                  style={{ flex: 1, padding: '8px 10px', borderRadius: 8, border: '1px solid #eee', fontSize: 13, fontFamily: 'inherit', color: '#2F2F2E', background: '#fff' }}>
                  {usuarios.map(u => <option key={u.id} value={u.id}>{u.id === usuario?.id ? `${u.nome} (minha agenda)` : u.nome}</option>)}
                </select>
              </label>
            )}
            {janela.delegado && (
              <p style={{ margin: 0, fontSize: 12, color: '#888' }}>
                Na agenda de <strong>{janela.donoNome}</strong> · {janela.concluido ? <strong style={{ color: '#2F6B3A' }}>Concluído</strong> : <strong style={{ color: '#B26A00' }}>Pendente</strong>}
              </p>
            )}
            {janela.criadoPorNome && (
              <p style={{ margin: 0, fontSize: 12, color: '#888' }}>Criado por <strong>{janela.criadoPorNome}</strong></p>
            )}

            <input value={janela.titulo} onChange={e => setJanela(j => ({ ...j, titulo: e.target.value }))} placeholder="Título do compromisso"
              style={{ padding: '9px 12px', borderRadius: 8, border: '1px solid #eee', fontSize: 13, fontFamily: 'inherit' }} />
            <div style={{ display: 'flex', gap: 8 }}>
              <input type="date" value={janela.data} onChange={e => setJanela(j => ({ ...j, data: e.target.value }))}
                style={{ flex: 1, padding: '9px 12px', borderRadius: 8, border: '1px solid #eee', fontSize: 13, fontFamily: 'inherit' }} />
              <input type="time" value={janela.hora} onChange={e => setJanela(j => ({ ...j, hora: e.target.value }))}
                style={{ width: 110, padding: '9px 12px', borderRadius: 8, border: '1px solid #eee', fontSize: 13, fontFamily: 'inherit' }} />
            </div>
            <div style={{ position: 'relative' }}>
              <input
                value={janela.clienteId ? clientes.find(c => c.id === janela.clienteId)?.nome || '' : buscaCliente}
                onChange={e => { setBuscaCliente(e.target.value); setJanela(j => ({ ...j, clienteId: null })); navCliente.reset() }}
                onKeyDown={navCliente.onKeyDown}
                placeholder="Vincular a um cliente (opcional)"
                style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1px solid #eee', fontSize: 13, fontFamily: 'inherit', boxSizing: 'border-box' }}
              />
              {!!clientesFiltrados.length && !janela.clienteId && (
                <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff', border: '1px solid #eee', borderRadius: 8, marginTop: 4, boxShadow: '0 4px 16px rgba(0,0,0,0.1)', zIndex: 5, maxHeight: 160, overflowY: 'auto' }}>
                  {clientesFiltrados.map((c, i) => (
                    <div key={c.id} onClick={() => { setJanela(j => ({ ...j, clienteId: c.id })); setBuscaCliente('') }}
                      onMouseEnter={() => navCliente.setIndice(i)}
                      style={{ padding: '8px 12px', fontSize: 13, cursor: 'pointer', background: i === navCliente.indice ? '#F9F6F5' : '#fff' }}
                    >{c.nome}</div>
                  ))}
                </div>
              )}
            </div>

            <textarea
              value={janela.descricao} onChange={e => setJanela(j => ({ ...j, descricao: e.target.value }))}
              placeholder="Detalhar (opcional)" rows={3}
              style={{ padding: '9px 12px', borderRadius: 8, border: '1px solid #eee', fontSize: 13, fontFamily: 'inherit', resize: 'vertical', boxSizing: 'border-box' }}
            />

            {erroJanela && (
              <p style={{ margin: 0, fontSize: 12, fontWeight: 600, color: '#BB0100', background: '#FDECEC', borderRadius: 8, padding: '8px 10px' }}>{erroJanela}</p>
            )}

            {janela.editandoId && !janela.delegado && (
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#2F2F2E', cursor: 'pointer' }}>
                <input type="checkbox" checked={janela.concluido} onChange={e => setJanela(j => ({ ...j, concluido: e.target.checked }))} style={{ cursor: 'pointer' }} />
                Concluído
              </label>
            )}

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 4 }}>
              {janela.editandoId ? (
                <button onClick={() => excluir(janela.editandoId)} title="Excluir" style={{
                  width: 22, height: 22, border: 'none', background: 'none', color: '#BB0100', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}><IconExcluir size={16} /></button>
              ) : <span />}
              <button onClick={salvar} disabled={salvando || !janela.titulo.trim() || !janela.data} style={{
                padding: '8px 18px', background: PRIMARY, color: '#fff', border: 'none',
                borderRadius: 8, fontWeight: 700, fontSize: 12, cursor: 'pointer',
                opacity: (salvando || !janela.titulo.trim() || !janela.data) ? 0.6 : 1,
              }}>Salvar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

// Janela "Compromissos de hoje": abre na 1a visita do dia a Home (por usuario, guardado no
// navegador), so se houver compromisso pendente hoje. Separa os meus dos criados por outros
// usuarios e deixa escolher quais viram tarefa no ToDo do Dia.
function ResumoDoDia({ usuarioId, onEnviado }) {
  const [aberto, setAberto] = useState(false)
  const [itens, setItens] = useState([])
  const [marcados, setMarcados] = useState(new Set())
  const [enviando, setEnviando] = useState(false)
  const [erro, setErro] = useState('')
  const hojeISO = isoLocal(new Date())

  useEffect(() => {
    if (!usuarioId) return
    const chave = `resumoDoDia:${usuarioId}`
    let jaViu = false
    try { jaViu = localStorage.getItem(chave) === hojeISO } catch { /* sem storage: mostra mesmo assim */ }
    if (jaViu) return
    api.get('/compromissos').then(res => {
      const lista = (Array.isArray(res.data) ? res.data : [])
        .filter(it => it.data.split('T')[0] === hojeISO && !it.delegado && !it.concluido)
      if (!lista.length) return
      try { localStorage.setItem(chave, hojeISO) } catch { /* ignora */ }
      setItens(lista)
      setMarcados(new Set(lista.map(it => it.id)))
      setAberto(true)
    }).catch(() => {})
  }, [usuarioId, hojeISO])

  if (!aberto) return null

  const meus = itens.filter(it => !it.criado_por_nome)
  const deOutros = itens.filter(it => it.criado_por_nome)
  const alternar = (id) => setMarcados(prev => { const n = new Set(prev); n.has(id) ? n.delete(id) : n.add(id); return n })
  const tituloTarefa = (it) => `${it.hora ? `${it.hora} - ` : ''}${it.titulo}${it.cliente_nome ? ` (${it.cliente_nome})` : ''}`

  const enviar = async () => {
    setEnviando(true)
    setErro('')
    try {
      // Nao duplica: pula o que ja esta no ToDo com o mesmo texto
      const { data: atuais } = await api.get('/tarefas', { params: { data: hojeISO } })
      const existentes = new Set((Array.isArray(atuais) ? atuais : []).map(t => t.titulo))
      for (const it of itens.filter(i => marcados.has(i.id))) {
        const titulo = tituloTarefa(it)
        if (!existentes.has(titulo)) await api.post('/tarefas', { titulo, data: hojeISO })
      }
      onEnviado()
      setAberto(false)
    } catch {
      setErro('Não foi possível enviar para o ToDo. Tente novamente.')
    } finally { setEnviando(false) }
  }

  const Coluna = ({ titulo, lista, vazio }) => (
    <div style={{ flex: '1 1 260px', minWidth: 0 }}>
      <p style={{ margin: '0 0 8px', fontSize: 11, fontWeight: 800, color: SECONDARY, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
        {titulo} ({lista.length})
      </p>
      {!lista.length ? (
        <p style={{ fontSize: 13, color: '#999', margin: 0 }}>{vazio}</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {lista.map(it => (
            <label key={it.id} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, padding: '9px 12px', background: '#F9F6F5', borderRadius: 10, cursor: 'pointer' }}>
              <input type="checkbox" checked={marcados.has(it.id)} onChange={() => alternar(it.id)} style={{ marginTop: 3, cursor: 'pointer' }} />
              <div style={{ minWidth: 0 }}>
                <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: '#2F2F2E' }}>{it.titulo}</p>
                <p style={{ margin: '2px 0 0', fontSize: 11, color: '#999' }}>
                  {it.hora || 'sem horário'}{it.cliente_nome ? ` · ${it.cliente_nome}` : ''}{it.criado_por_nome ? ` · por ${it.criado_por_nome}` : ''}
                </p>
              </div>
            </label>
          ))}
        </div>
      )}
    </div>
  )

  return (
    <div onClick={() => setAberto(false)} style={{
      position: 'fixed', inset: 0, background: 'rgba(47,47,46,0.45)', zIndex: 1000,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: '#fff', borderRadius: 16, padding: 24, width: '100%', maxWidth: 680, maxHeight: '85vh', overflowY: 'auto',
        boxShadow: '0 12px 40px rgba(0,0,0,0.25)', fontFamily: 'Manrope, sans-serif',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
          <div>
            <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800, color: '#2F2F2E' }}>📅 Compromissos e Tarefas de Hoje</h3>
            <p style={{ margin: '4px 0 0', fontSize: 12, color: '#888' }}>Marque o que quer enviar para o ToDo do Dia.</p>
          </div>
          <button onClick={() => setAberto(false)} style={{ border: 'none', background: 'none', color: '#bbb', cursor: 'pointer', fontSize: 18, lineHeight: 1 }}>✕</button>
        </div>

        <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
          <Coluna titulo="Meus" lista={meus} vazio="Nenhum compromisso seu hoje." />
          <Coluna titulo="Criados por outros usuários" lista={deOutros} vazio="Nenhum compromisso criado por outros hoje." />
        </div>

        {erro && <p style={{ margin: '14px 0 0', fontSize: 12, fontWeight: 600, color: '#BB0100', background: '#FDECEC', borderRadius: 8, padding: '8px 10px' }}>{erro}</p>}

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 20, gap: 10, flexWrap: 'wrap' }}>
          <button onClick={() => setMarcados(marcados.size === itens.length ? new Set() : new Set(itens.map(i => i.id)))} style={{
            border: 'none', background: 'none', color: PRIMARY, fontWeight: 700, fontSize: 12, cursor: 'pointer', padding: 0,
          }}>{marcados.size === itens.length ? 'Desmarcar todos' : 'Marcar todos'}</button>
          <div style={{ display: 'flex', gap: 10 }}>
            <button onClick={() => setAberto(false)} style={{
              padding: '9px 16px', background: '#fff', color: '#666', border: '1px solid #e5e5e5', borderRadius: 8, fontWeight: 700, fontSize: 12, cursor: 'pointer',
            }}>Fechar</button>
            <button onClick={enviar} disabled={enviando || !marcados.size} style={{
              padding: '9px 18px', background: PRIMARY, color: '#fff', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: 12,
              cursor: 'pointer', opacity: (enviando || !marcados.size) ? 0.6 : 1,
            }}>{enviando ? 'Enviando…' : `Enviar para o ToDo do Dia (${marcados.size})`}</button>
          </div>
        </div>
      </div>
    </div>
  )
}

function TodoDia() {
  const [itens, setItens] = useState([])
  const [carregando, setCarregando] = useState(true)
  const [novo, setNovo] = useState('')

  const hojeISO = new Date().toISOString().split('T')[0]

  const carregar = () => {
    setCarregando(true)
    api.get('/tarefas', { params: { data: hojeISO } }).then(res => setItens(Array.isArray(res.data) ? res.data : [])).finally(() => setCarregando(false))
  }
  useEffect(() => { carregar() }, [])

  const adicionar = async () => {
    if (!novo.trim()) return
    const titulo = novo.trim()
    setNovo('')
    const { data } = await api.post('/tarefas', { titulo, data: hojeISO })
    setItens(prev => [...prev, data])
  }

  const alternarFeito = async (item) => {
    setItens(prev => prev.map(i => i.id === item.id ? { ...i, feito: !i.feito } : i))
    await api.patch(`/tarefas/${item.id}`, { feito: !item.feito })
  }

  const excluir = async (id) => {
    setItens(prev => prev.filter(i => i.id !== id))
    await api.delete(`/tarefas/${id}`)
  }

  const diasPendente = (dataStr) => {
    const d = new Date(dataStr.split('T')[0] + 'T00:00:00')
    const hoje = new Date(hojeISO + 'T00:00:00')
    return Math.round((hoje - d) / 86400000)
  }

  return (
    <div style={{ background: '#fff', borderRadius: 16, padding: '20px 22px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
      <h3 style={{ fontSize: 15, fontWeight: 800, color: '#2F2F2E', margin: '0 0 14px' }}>✅ ToDo do Dia</h3>

      <div style={{ display: 'flex', gap: 8, marginBottom: 14 }}>
        <input
          value={novo} onChange={e => setNovo(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') adicionar() }}
          placeholder="Nova tarefa…"
          style={{ flex: 1, padding: '9px 12px', borderRadius: 8, border: '1px solid #eee', fontSize: 13, fontFamily: 'inherit', minWidth: 0 }}
        />
        <button onClick={adicionar} style={{
          padding: '9px 14px', background: PRIMARY, color: '#fff', border: 'none',
          borderRadius: 8, fontWeight: 700, fontSize: 13, cursor: 'pointer',
        }}>+</button>
      </div>

      {carregando ? (
        <p style={{ fontSize: 13, color: '#999' }}>Carregando…</p>
      ) : !itens.length ? (
        <p style={{ fontSize: 13, color: '#999' }}>Nenhuma tarefa para hoje.</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 320, overflowY: 'auto' }}>
          {itens.map(item => {
            const dias = diasPendente(item.data)
            return (
              <div key={item.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px', background: '#F9F6F5', borderRadius: 8, opacity: item.feito ? 0.5 : 1 }}>
                <input type="checkbox" checked={!!item.feito} onChange={() => alternarFeito(item)} style={{ cursor: 'pointer' }} />
                <p style={{ flex: 1, margin: 0, fontSize: 13, color: '#2F2F2E', textDecoration: item.feito ? 'line-through' : 'none' }}>{item.titulo}</p>
                {!item.feito && dias > 0 && (
                  <span style={{
                    fontSize: 10, fontWeight: 700, color: '#BB0100', background: 'rgba(187,1,0,0.08)',
                    padding: '3px 8px', borderRadius: 999, whiteSpace: 'nowrap',
                  }}>{dias === 1 ? 'há 1 dia' : `há ${dias} dias`}</span>
                )}
                <button onClick={() => excluir(item.id)} style={{ border: 'none', background: 'none', color: '#bbb', cursor: 'pointer', fontSize: 14 }}>✕</button>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

function CardSeguradoras() {
  const [lista, setLista] = useState([])
  const [carregando, setCarregando] = useState(true)
  const [selecionadaId, setSelecionadaId] = useState('')

  useEffect(() => {
    api.get('/cadastro/seguradoras').then(res => setLista(Array.isArray(res.data) ? res.data : [])).finally(() => setCarregando(false))
  }, [])

  const seguradora = lista.find(s => String(s.id) === selecionadaId)
  const tels = Array.isArray(seguradora?.telefones) ? seguradora.telefones.filter(t => t.numero?.trim()) : []
  const links = Array.isArray(seguradora?.links) ? seguradora.links.filter(l => l.link?.trim()) : []
  const endereco = seguradora ? [
    seguradora.rua && `${seguradora.rua}${seguradora.numero ? `, ${seguradora.numero}` : ''}`,
    seguradora.complemento, seguradora.bairro,
    seguradora.cidade && `${seguradora.cidade}${seguradora.estado ? `/${seguradora.estado}` : ''}`,
    seguradora.cep,
  ].filter(Boolean).join(' — ') : ''

  return (
    <div style={{ background: '#fff', borderRadius: 16, padding: '20px 22px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
      <h3 style={{ fontSize: 15, fontWeight: 800, color: '#2F2F2E', margin: '0 0 14px' }}>Seguradoras</h3>

      <select
        value={selecionadaId} onChange={e => setSelecionadaId(e.target.value)}
        style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1px solid #eee', fontSize: 13, fontFamily: 'inherit', boxSizing: 'border-box', color: selecionadaId ? '#2F2F2E' : '#999' }}
      >
        <option value="">{carregando ? 'Carregando…' : 'Selecione uma seguradora'}</option>
        {lista.map(s => <option key={s.id} value={s.id}>{s.nome}</option>)}
      </select>

      {seguradora && (
        <div style={{ background: '#F9F6F5', borderRadius: 12, padding: 14, marginTop: 12, display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div>
            <p style={{ margin: 0, fontSize: 17, fontWeight: 800, color: '#2F2F2E' }}>{seguradora.nome}</p>
            {seguradora.abreviacao && <p style={{ margin: '2px 0 0', fontSize: 13, color: '#999' }}>{seguradora.abreviacao}</p>}
          </div>

          <div style={{ fontSize: 14, color: '#555', display: 'flex', flexDirection: 'column', gap: 6 }}>
            <div>Gerente: {seguradora.gerente_nome || '—'}</div>
            <div>{seguradora.gerente_telefone || '—'}</div>
            <div>{seguradora.gerente_email || '—'}</div>
            <div>Sucursal {seguradora.sucursal || ''}: {seguradora.sucursal_telefone || '—'}</div>
          </div>

          {(seguradora.razao_social || seguradora.cnpj) && (
            <div style={{ fontSize: 14, color: '#555', paddingTop: 10, borderTop: '1px solid rgba(0,0,0,0.06)' }}>
              {seguradora.razao_social && <div>{seguradora.razao_social}</div>}
              {seguradora.cnpj && <div>CNPJ: {seguradora.cnpj}</div>}
            </div>
          )}

          {endereco && <div style={{ fontSize: 14, color: '#555' }}>{endereco}</div>}

          {seguradora.observacao && (
            <div style={{ fontSize: 13.5, color: '#777', fontStyle: 'italic' }}>{seguradora.observacao}</div>
          )}

          {(tels.length > 0 || links.length > 0) && (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, paddingTop: 10, borderTop: '1px solid rgba(0,0,0,0.06)' }}>
              {tels.map((t, i) => (
                <span key={i} style={{ fontSize: 13, color: '#777', display: 'flex', alignItems: 'center', gap: 6 }}>
                  <span>{t.tipo === 'Whatsapp' ? '📱' : '📞'}</span> {t.tipo}: {t.numero}
                </span>
              ))}
              {links.map((l, i) => (
                <a key={i} href={l.link} target="_blank" rel="noreferrer"
                  style={{ fontSize: 13, color: PRIMARY, textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 6 }}>
                  <span>🔗</span> {l.tipo}{l.observacao ? ` "${l.observacao}"` : ''}
                </a>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  )
}

// Duas colunas fixas (texto | icone) e tamanhos que acompanham a largura da tela (clamp): com o
// card estreito (zoom 100% em tela menor) o texto nao empurra mais o icone pra fora do lugar.
function KPICard({ icon, label, value, color, iconSize = 50, onClick }) {
  return (
    <div onClick={onClick} style={{
      background: '#fff', borderRadius: 16, padding: '20px 18px',
      boxShadow: '0 1px 4px rgba(0,0,0,0.06)', cursor: 'pointer',
      display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) auto', alignItems: 'center', gap: 8,
      transition: 'box-shadow 0.15s', overflow: 'hidden',
    }}
      onMouseEnter={e => e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.1)'}
      onMouseLeave={e => e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.06)'}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, minWidth: 0 }}>
        <p style={{ fontSize: 11, fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: '0.08em', margin: 0, textAlign: 'center', maxWidth: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{label}</p>
        <h3 style={{ fontSize: 'clamp(34px, 3.4vw, 51px)', fontWeight: 900, color: '#2F2F2E', margin: 0, lineHeight: 1 }}>{value}</h3>
      </div>
      <div style={{ width: 'clamp(40px, 4.2vw, 64px)', aspectRatio: '1', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: `clamp(${Math.round(iconSize * 0.7)}px, ${(iconSize / 15).toFixed(2)}vw, ${iconSize}px)`, fontWeight: 400, lineHeight: 1, color }}>
        {icon}
      </div>
    </div>
  )
}
